<script lang="ts" setup>
import {route} from "ziggy-js"
import {router} from "@inertiajs/vue3";
import {Project} from "@/types";
import {computed} from "vue";

interface Props {
    url: string,
    icon: string,
    label: string,
    project: Project,
}

const props = defineProps<Props>()
const goTo= () => router.visit(route(props.url, {project: props.project.slug}))
const isActive = computed(() => route().current(props.url))
</script>

<template>
    <v-list-item
        link
        class="text-body-2"
        active-class="left-blue-border"
        :input-value="isActive"
        @click="goTo"
    >
        <v-list-item-icon class="mr-0">
            <v-icon
                small
                left
                class="mr-1"
            >
                {{ icon }}
            </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
            <v-list-item-title
                :class="`text-body-2 ${isActive ? 'font-weight-bold' : 'font-weight-regular'}`"
            >
                {{ label }}
            </v-list-item-title>
        </v-list-item-content>
    </v-list-item>
</template>

<style scoped>

</style>
